export default __webpack_public_path__ + "static/global-contact-e359a5bdc87c5a3e21b30e5d4839e94c.svg";